import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
// import FixProfileNavbar from "../../Components/Navbar/FixProfileNavbar";
// import AvailabilityCalendar from "../Availability/_calender";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"
import { connect } from "react-redux"

import TeacherInfoHeader from "./TeacherInfoHeader"
// import axios from "axios"
// import { PORT } from "../../config";

// import MyCalendar from "./toast.ui.js"
import MyCalendar from "../Availability/toast.ui";
const Moment = require("moment")
const MomentRange = require("moment-range")
const moment = MomentRange.extendMoment(Moment)


export class TeacherCalendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // user: JSON.parse(window.localStorage.getItem("teacher"))
      user: JSON.parse(window.sessionStorage.getItem("admin-check-teacher")),
    }
    if (this.state.user === null) {
      window.location = "/login"
    }
  }

  componentDidMount = () => {
  }

  isSelect = (time, date) => {
    let newdate = moment(date).format("MM-DD-YYYY")
    const userData = this.state.user
    let flag = false
    if (userData.rules[0]) {
      if (userData.rules[0][newdate] && userData.rules[0][newdate].time) {
        // if (userData.rules[0][newdate] && time && newdate) {
        console.log(
          userData.rules[0][newdate].time +
          "---------" +
          time +
          "-----------" +
          newdate
        )
        console.log(userData.rules[0][newdate].time.includes(time))
        flag = userData.rules[0][newdate].time.includes(time)
        return flag
      }
    }
    return flag
  }

  render() {
    return (
      <AdminWrapper>
        <SwitchMenuBar isViewAsTeacher />

        <div className="auth-right d-lg-flex bg-photoregister ">
          <div className="bg-gradient"></div>
          <div className="profile-container">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <TeacherInfoHeader user={this.state.user} />
                <div className="mt-5">

                  {/* navigationbar on top */}
                  <div className="userNavigation d-flex justify-content-between">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
                    >
                      <p>BACK</p>
                    </Link>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherNotes"
                          }
                        }
                        className="user-links  d-flex user-links-background-transparent "
                      >
                        <p>Team Notes</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherpersonalDetails"
                          }
                        }
                        className="user-links d-flex user-links-background-transparent "
                      >
                        <p>P.Info/I.D.</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherBanking",
                        }}
                        className="user-links text-center d-flex  "
                      >
                        <p>Banking</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/validatedocuments",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Uploads</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          //pathname: "/TeacherCalendar",
                        }}
                        className="user-links user-links-active text-center d-flex "
                      >
                        <p>Calendar</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherJoblistAdmin",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>JobList</p>
                      </Link>
                    </div>
                  </div>

                  <div className="availability-table-container">
                    <div className="availability-table">
                      <div className="availability-table-body mb-5">
                        <div className="availability-table-body-content">
                          <MyCalendar
                            user={this.state.user}
                            isSelect={this.isSelect}
                            isAdmin
                          ></MyCalendar>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* navigationbar on bottom */}
                  <div className="adminBottomNavigation ">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                    >
                      <p>BACK - All Teachers</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminWrapper>
    )
  }
}

function mapStateToProps(state) {
  return {
    teacher: state.admin.teacher,
  }
}

export default connect(mapStateToProps)(TeacherCalendar)
